import { render, staticRenderFns } from "./rechargeByFuyou.vue?vue&type=template&id=2b2b0955&scoped=true&"
import script from "./rechargeByFuyou.vue?vue&type=script&lang=js&"
export * from "./rechargeByFuyou.vue?vue&type=script&lang=js&"
import style0 from "./rechargeByFuyou.vue?vue&type=style&index=0&id=2b2b0955&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2b0955",
  null
  
)

export default component.exports